var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 39,
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.164 6.545v3.099h4.393c-.193.996-.771 1.84-1.64 2.407l2.65 2.014C15.11 12.67 16 10.619 16 8.183c0-.567-.052-1.113-.149-1.637H8.164Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.588 9.523-.598.448-2.115 1.614A8.18 8.18 0 0 0 8.162 16c2.204 0 4.052-.713 5.403-1.934l-2.65-2.015c-.727.48-1.654.77-2.753.77-2.122 0-3.925-1.403-4.571-3.294l-.003-.004Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.876 4.415a7.774 7.774 0 0 0 0 7.17c0 .008 2.716-2.065 2.716-2.065-.163-.48-.26-.99-.26-1.52 0-.531.097-1.04.26-1.52L.876 4.415Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.163 3.185c1.202 0 2.27.408 3.124 1.193l2.337-2.29C12.207.792 10.367 0 8.163 0A8.167 8.167 0 0 0 .875 4.415L3.591 6.48c.646-1.89 2.45-3.295 4.572-3.295Z",
  fill: "#EA4335"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgGoogle as Component };